import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";
import { HightlightStyleClasses } from "assets/jss/common-styles";

export type HeaderStylesClassKey =
    | 'buttonMenu'
    | 'searchInfo'
    | 'searchInput'
    | 'searchInner'
    | 'searchOuter'
    | 'pooperNav'
    | 'popperClose'
    | 'notifications'
    | 'manager'
    | 'menuItem'
    | 'dropdownWrapper'
    | 'dropdownListRoot'
    | 'dropdownListContainer'
    | 'dropdownListContainerWrapper'
    | 'dropdownListItem'
    | 'dropdownListItemAvatar'
    | 'dropdownTabRoot'
    | 'dropdownCard'
    | 'dropdownCardHeader'
    | 'dropdownCardHeaderAction'
    | 'dropdownCardContent'
    | 'newItemLeftMark'
    ;

const headerLinksStyle = (theme: Theme) => createStyles({

    ...HightlightStyleClasses(theme),

    buttonMenu: {
        margin: 0,
        display: "flex",
    },

    linkText: {
        zIndex: 4,
        fontSize: "14px",
        margin: "0px"
    },

    pooperNav: {
    },

    popperClose: {
        pointerEvents: "none"
    },


    searchOuter: {
        display: "inline-block",
        paddingTop: "4px",
        paddingLeft: "4px",
        paddingRight: "4px",
        flexGrow: 1,
        marginLeft: "10px",
        marginRight: "10px",
        position: "relative",
        "&.searching": {
            backgroundColor: "transparent"
        }
    },

    searchInner: {
        position: "relative"
    },

    searchInput: {
        backgroundColor: "#fff",
        color: "#000",
        border: 0,
        borderRadius: "10px",
        width: "100%",
        "&:focus": {
            outline: "none",
        },
        "& input": {
            padding: "8px",
        }
    },

    searchInfo: {
        position: "absolute",
        width: "100%",
        padding: 8,
        marginTop: 1,
        borderRadius: "10px",
    },


    notifications: {
        zIndex: 4,

        position: "absolute",
        top: "2px",
        border: "1px solid #FFF",
        right: "4px",
        fontSize: "9px",
        background: theme.palette.error.dark,
        color: theme.palette.error.contrastText,
        minWidth: "16px",
        borderRadius: "10px",
        textAlign: "center",
        lineHeight: "16px",
        verticalAlign: "middle",
        display: "block"

    },

    manager: {
        display: "flex",
        "& img": {
            borderRadius: "50%"
        }
    },

    menuItem: {
        fontSize: "13px",
        padding: "10px 20px",
        margin: "0 5px",
        borderRadius: "2px",
        WebkitTransition: "all 150ms linear",
        MozTransition: "all 150ms linear",
        OTransition: "all 150ms linear",
        MsTransition: "all 150ms linear",
        transition: "all 150ms linear",
        display: "block",
        clear: "both",
        fontWeight: 400,
        lineHeight: "initial",
        minHeight: "initial",
        color: theme.palette.primary.dark,
        whiteSpace: "nowrap",
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            color: "#FFFFFF",
            boxShadow: theme.genie.boxShadow.primary
        }
    },

    // ---> DROPDOWN <---

    dropdownWrapper: {
        width: 360,
    },

    dropdownListRoot: {
        color: "#000",
        paddingTop: 0,
        paddingBottom: 0,
    },

    dropdownListContainer: {
        margin: 4,
        wordBreak: "break-word"
    },

    dropdownListContainerWrapper: {
        maxHeight: 300,
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
    },

    dropdownListItem: {
    },

    dropdownTabRoot: {
        minWidth: "auto",
        "& @media (min-width: 960px)": {
            minWidth: "inherit",
        }
    },

    dropdownListItemAvatar: {
        width: 50,
        height: 50,
        alignItems: "flex-start",
        textAlign: "center",
    },

    // ---> CARD <---
    dropdownCard: {
        paddingLeft: 0,
        paddingRight: 0,
        background: theme.palette.grey[200]
    },

    dropdownCardHeader: {
        paddingLeft: 16,
        paddingRight: 0,
        paddingTop: 8,
        paddingBottom: 8
    },
    dropdownCardHeaderAction: {
        marginTop: 0,
        marginRight: 0,
        alignSelf: "center"
    },
    dropdownCardContent: {
        padding: 0,
        "&:last-child": {
            paddingBottom: 0
        }
    },
});

export default headerLinksStyle;
